import { Injectable } from "@angular/core";
import { Platform, MenuController } from "@ionic/angular";
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Storage } from "@ionic/storage-angular";
import { map } from "rxjs/operators";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AppConfig } from "./app/app.config";
import { Router } from "@angular/router";
//import path from 'path';

@Injectable()
export class Global {
  // Detail to Back End
  public XRSBaseURLWebLMS: string;
  public XRSBaseURLWCFServices: string;
  public XRSReportServiceRoot: string;
  public XRSBaseURLServices: string;
  public XRSBackendURL: string;
  public XRSClickerBaseURL: string;
  public XRSUnity: string;
  public XRSCore: string;
  public XRSSAMRedirectURL: string;
  public XRXUserClients: any = [];
  public XRS_Description_For_Schema: string;

  public XRSBaseAppNameURL: string; //http://locolhost/weblms
  public XRSCustomURL: string;
  public XRSUser: any;
  public XRSTokenKey: string;
  // Front End Settings for SplitPane, Headers
  public ContentPageTitle: string;
  public NoSplitPane: boolean = true;
  // No header in Left Menu if the value is true
  public NoLeftMenuHeader: boolean;
  // No header in Right Menu if the value is true
  public NoRightMenuHeader: boolean;
  // No header in Main Content Page if the value is true
  public NoContentPageHeader: boolean;
  public NoToolbar: boolean;
  public NoTopBar;
  // URL to the order.aspx page to do payfast payment
  public PayFastOrderPage: string;
  public UserFee: number;
  //true == use WebLMS TrainingCentre | false == use XRS Training Centre
  public useWebLMSTrainingCentre: boolean;
  public regionList: any = [];
  public landingObj: any = {};

  public TotalNumberOfFilesToDownload: any;
  public CurrentNumberDownloadFile: any;
  public PercentageFilesDownloaded: BehaviorSubject<any>;
  public OfflineEnabled: boolean = false;

  //togle fullscreen
  // public docElement: HTMLElement;
  public isFullScreen: boolean = false;
  private docElement: any = document.documentElement;

  public IsOnline: boolean = true; //Change this to false when working with offline

  public SubscriptionExpireDate: any;
  public SubscriptionDaysLeft: any;

  constructor(
    public menu: MenuController,
    public platform: Platform,
    private helper: JwtHelperService,
    private storage: Storage,
    private http: HttpClient,
    private config: AppConfig,
    private router: Router
  ) {
    this.PercentageFilesDownloaded = new BehaviorSubject<any>(0);
    if (sessionStorage.getItem("baseUrlServices") === null) {
      this.XRSBackendURL = config.getConfig("baseUrlServices");
    } else {
      this.XRSBackendURL = sessionStorage.getItem("baseUrlServices");
    }

    if (sessionStorage.getItem("reportServiceRoot") === null) {
      this.XRSReportServiceRoot = config.getConfig("reportServiceRoot");
    } else {
      this.XRSReportServiceRoot = sessionStorage.getItem("reportServiceRoot");
    }

    if (sessionStorage.getItem("xrsunity") === null) {
      this.XRSUnity = config.getConfig("xrsunity");
    } else {
      this.XRSUnity = sessionStorage.getItem("xrsunity");
    }

    // if (sessionStorage.getItem("SAMRedirectURL") === null) {
    //   this.XRSSAMRedirectURL = config.getConfig("SAMRedirectURL");
    // } else {
    //   this.XRSSAMRedirectURL = sessionStorage.getItem("SAMRedirectURL");
    // }

    this.XRSBaseURLWebLMS = config.getConfig("baseUrlWebLMS");

    this.XRSBaseURLWCFServices = config.getConfig("baseUrlWCFServices");
    this.useWebLMSTrainingCentre = config.getConfig("useWebLMSTrainingCentre");
    this.XRSClickerBaseURL = config.getConfig("clickerBaseURL");

    this.OfflineEnabled = config.getConfig("offlineEnabled");
    this.XRSCore = config.getConfig("xrscore");

    this.XRSCustomURL = this.XRSBaseURLWebLMS + "/Resources/LMS/CustomContent/";

    this.NoLeftMenuHeader = false;
    this.NoRightMenuHeader = false;
    this.NoContentPageHeader = false;
    this.NoToolbar = false;
    this.NoTopBar = false;

    this.PayFastOrderPage = config.getConfig("payFastOrderPage");
    this.UserFee = config.getConfig("userFee");

    this.docElement = document.documentElement;

    // this.storage.get('xrsUser').then((xrsUser) => {
    //   this.XRSUser = xrsUser;

    // });
  }
  private extractData(res: Response) {
    // tslint:disable-next-line:prefer-const
    let body = res;
    return body || {};
  }

  isSerializable(value: any): boolean {
    try {
      JSON.stringify(value);
      return true;
    } catch (e) {
      return false;
    }
  }

  sanitizeGlobals(): any {
    const sanitized: any = {};

    Object.keys(this).forEach((key: string) => {
      //skip this
      if (!key.includes("XRXUserClients")) {
        let value = (this as any)[key];

        if (this.isSerializable(value)) {
          // If it's serializable, add it to the sanitized object
          sanitized[key] = value;
        }
      }
    });

    return sanitized;
  }

  // Save the entire Globals object to sessionStorage as a single entry
  saveGlobalsToSessionStorage() {
    const sanitizedGlobals = this.sanitizeGlobals();

    // Store the sanitized object in sessionStorage
    sessionStorage.setItem("Globals", JSON.stringify(sanitizedGlobals));
  }

  // Load the Globals object from sessionStorage and assign it back to the Globals service
  loadGlobalsFromSessionStorage() {
    const storedGlobals = sessionStorage.getItem("Globals");

    if (storedGlobals) {
      const parsedGlobals = JSON.parse(storedGlobals);

      Object.keys(parsedGlobals).forEach((key: string) => {
        // Assign the parsed value back to the Globals service
        (this as any)[key] = parsedGlobals[key];
      });

      sessionStorage.removeItem("Globals");
    }
  }

  NavigateToHome() {
    this.router.navigate(["home"]);
  }

  GetXRSCustomContentURL() {
    return this.XRSBaseURLWebLMS + sessionStorage.getItem("xrsunity");
  }

  GetFileNameFromPath(pathofFile: string) {
    //const filePath = pathofFile;
    //return path.basename(pathofFile);
    return pathofFile.replace(/^.*[\\\/]/, "");
  }

  /*GetConfigValues(): Observable<any> {
    return this.http
      .get("./assets/config/config.json")
      .pipe(map(this.extractData));
  }*/
  //multi frontend : this is to make ensure that the correct relative config.json is used
  GetConfigValues(): Observable<any> {
    // Get the current sub-path (e.g., 'client1' or 'client2')
    const pathArray = window.location.pathname.split("/");
    const subPath = pathArray.length > 1 ? pathArray[1] : ""; // Detect sub-path from URL
    //const configUrl = (window.location.port && window.location.hostname == "localhost") ? '../assets/config/config.json' : `/${subPath}/assets/config/config.json`; // Build URL dynamically
    const configUrl = "../assets/config/config.json"; //Single frontend

    // Fetch the config.json file from the correct sub-path
    return this.http.get(configUrl).pipe(map(this.extractData));
  }
  // Function to enable or disable any menu
  enable_menu(menuID: string, menu_enabled: boolean) {
    this.menu.enable(menu_enabled, menuID);
  }

  hide_menu(menuID: string, menu_enabled: boolean) {
    this.menu.close(menuID);
  }

  generateNumberFromString(input: string): number {
    // Convert the string to a hash value
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Convert the hash to a number between 1 and 9
    const randomNumber = (Math.abs(hash) % 9) + 1;

    return randomNumber;
  }

  number(): number {
    return Math.floor(Math.random() * 9) + 1;
  }

  // onThumbnailError(event: any, file: any, text: string) {
  //   var number = 1;
  //   if (text != null) {
  //     number = this.generateNumberFromString(text);
  //   } else {
  //     number = -1; //this.number();
  //   }

  //   var fileWithoutExtension = file.split(".").slice(0, -1).join(".");
  //   var filexExtensionOnly = file.split(".").pop() || "";
  //   event.target.src =
  //     this.GetXRSCustomContentURL() +
  //     "Thumbnails/" +
  //     fileWithoutExtension +
  //     (number > 0 ? number : "") +
  //     "." +
  //     filexExtensionOnly;
  // }
  onThumbnailError(event: any, fallbackFile: string, text?: string) {
    const currentSrc = event.target.src;
    let fileWithoutExtension = fallbackFile.split(".").slice(0, -1).join(".");
    let fileExtension = fallbackFile.split(".").pop() || "";

    let number = text ? this.generateNumberFromString(text) : -1;

    if (
      !currentSrc ||
      currentSrc.trim() === "" ||
      currentSrc.includes("undefined")
    ) {
      event.target.src = `assets/CustomContent/Thumbnails/${fallbackFile}`;
    }

    let fallbackSrc =
      this.GetXRSCustomContentURL() +
      "Thumbnails/" +
      fileWithoutExtension +
      (number > 0 ? number : "") +
      "." +
      fileExtension;

    event.target.src =
      fallbackSrc.includes("undefined") || !fallbackFile
        ? `assets/CustomContent/Thumbnails/${fallbackFile}`
        : fallbackSrc;
  }

  getThmbnailPath(ContentGUID: string, alt: string) {
    
    var path =
      this.GetXRSCustomContentURL() + "Thumbnails/" + ContentGUID + ".jpg";

    if (path.includes("null"))
      return this.GetXRSCustomContentURL() + "Thumbnails/" + alt;
    else return path;
  }

  fixXRSUser() {
    this.storage.get("JFRTQGQqJl5taW40Njgw").then((token) => {
      if (token) {
        // tslint:disable-next-line:prefer-const
        let decoded = this.helper.decodeToken(token);
        // tslint:disable-next-line:prefer-const
        let isExpired = this.helper.isTokenExpired(token);
        if (!isExpired) {
          let user = decoded;
          var userObjDecoded = JSON.parse(decoded.User);
          userObjDecoded.UserToken = token;

          this.XRSUser = userObjDecoded;

          // let authenticated = true;
          // this.authenticationState.emit(true);
        } else {
          this.storage.remove("JFRTQGQqJl5taW40Njgw");
        }
      }
      // else{
      //   this.authenticated = false;
      //   this.authenticationState.emit(false);
      // }
    });
  }

  contains(text: any, toCompare: any) {
    var found = false;
    toCompare.forEach((element) => {
      if (text.includes(element)) {
        return true;
      }
    });

    return found;
  }

  checkFunctionAccess(menu: any) {
    if (this.XRSUser == null) {
      return false;
    } else if (
      this.XRSUser.Role_GUID == "E9C5F241-C0E7-4AC7-9986-88172BCED611"
    ) {
      return true;
    } else {
      var userTypeCode: string = this.XRSUser.XRSUserTypeCode;
      var result: Boolean = false;
      switch (menu) {
        case "Training": {
          result = true;
          break;
        }
        case "Users": {
          result = ["VA", "VF", "SA", "SA1", "SF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Lessons": {
          result = ["SF", "SA", "SA1", "VA"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Forms": {
          result = ["SF", "SA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Qualifications": {
          result = ["SF", "SA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Resource Manager": {
          result = ["VA", "VF", "SA", "SA1"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Contractors": {
          //result = ['VA','VF','SA','SA1'].includes(userTypeCode) ? true : false;
          //result = ['VA','VF','SA','SA1','VA1','VA2','VA3','VA4'].includes(userTypeCode) ? true : false;
          result = [
            // "VA",
            "SA",
            "SA1",
            // "SA2",
            // "SA3",
            // "SA4",
            // "SA5",
            "VA1",
            "VA2",
            "VA3",
            "VA4",
          ].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Business Partner": {
          result = ["VA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Vehicles": {
          result = ["VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Equipment": {
          result = ["VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Distribution List": {
          result = ["SA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Scope of Work": {
          //result = ['VA','SA','SA1','SA2','SA3','SA4','SA5'].includes(userTypeCode) ? true : false;
          result = [
            "VA",
            "SA",
            "SA1",
            "SA2",
            "SA3",
            "SA4",
            "SA5",
            "VA1",
            "VA2",
            "VA3",
            "VA4",
          ].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Procedures": {
          result = ["SA", "SA1", "SA2", "SA3", "SA4", "SA5"].includes(
            userTypeCode
          )
            ? true
            : false;
          break;
        }
        case "Visitors": {
          result = ["SA", "SA1", "SA2", "SA3", "SA4", "SA5", "SF"].includes(
            userTypeCode
          )
            ? true
            : false;
          break;
        }
        case "Lesson Builder": {
          result = ["SA", "SA1", "SF", "VA"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Media": {
          result = ["SA", "SA1", "SF"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Lessons": {
          result = ["SA", "SA1", "SF"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Administration": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Licensing": {
          result = ["VA", "SA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Price Plans": {
          result = this.XRSUser.GUID == "86d9fd7c-ea6f-4326-a3a1-95d4bf5f95af";
          break;
        }
        case "Subscription": {
          result = this.XRSUser.GUID == "86d9fd7c-ea6f-4326-a3a1-95d4bf5f95af";
          break;
        }
        case "Configuration": {
          result = ["SA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Data Lists": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Geographical Regions": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Sites": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Work Schedules": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Work Area": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Titles": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Village": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "JobTitle": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Races": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Housing Statuses": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Mine Rental Types": {
          result = ["SA", "SA1", "VA"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Reports": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Settings": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Sessions": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "People Groups": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "People Import": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Site Assignment": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Visitors": {
          result = ["VA", "VF", "SF"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Qualifications": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Virtual Reality": {
          result = ["SA", "SA1", "SF", "VA"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Site configuration": {
          result = ["SA", "SA1"].includes(userTypeCode) ? true : false;
          break;
        }
        case "Manage content": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }
        case "Resources": {
          result = ["SA", "SA1", "SF", "VA", "VF"].includes(userTypeCode)
            ? true
            : false;
          break;
        }

        default: {
          result = true;
        }
      }
      return result;
    }
  }

  // toggleFullScreen(gofullScreen:boolean) {

  //   if (gofullScreen) {
  //     this.docElement.requestFullscreen();

  //   }
  //   else {
  //     document.exitFullscreen();
  //   }
  //   this.isFullScreen = gofullScreen;

  // }

  toggleFullScreen(gofullScreen: boolean) {
    if (gofullScreen) {
      this.docElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    this.isFullScreen = gofullScreen;
  }
}
